// @flow
import Journey from "common/records/Journey"

type SetShadowJourney = {|
  type: "SET_SHADOW_JOURNEY",
  payload: Journey,
|}

export type Action = SetShadowJourney

export const setShadowJourney = (journey: Journey): SetShadowJourney => ({
  type: "SET_SHADOW_JOURNEY",
  payload: journey,
})
